import { render, staticRenderFns } from "./SettingsElectronicsPanel.vue?vue&type=template&id=51f4f650&scoped=true"
import script from "./SettingsElectronicsPanel.vue?vue&type=script&lang=ts"
export * from "./SettingsElectronicsPanel.vue?vue&type=script&lang=ts"
import style0 from "./SettingsElectronicsPanel.vue?vue&type=style&index=0&id=51f4f650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f4f650",
  null
  
)

export default component.exports